import NewsletterContainer from '../../../../components/containers/NewsletterContainer';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'newsletter--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: NewsletterContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
